<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap class="mb-3">
              <v-flex xs12>
                <h3>Přehled elektronických peněženek</h3>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm3>
                <osobasearch label="Osoba" v-model="osoba" class="mx-2" :all="true"></osobasearch>
              </v-flex>
              <v-flex xs12 sm9>
                <v-checkbox label="Pouze nenulové položky" v-model="only_not_null"></v-checkbox>
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1">
              <v-data-table
                :headers="headers"
                :items="items"
                :loading="loadingTable"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="[25, 50, 100, 200]"
              >
                <template slot="items" slot-scope="props">
                  <td>
                    <router-link :to="{ path: '/klienti/' + props.item.osoba.id }" target="_blank">
                      {{ props.item.nazev_osoby_razeni }}
                    </router-link>
                  </td>
                  <td>
                    <div v-if="props.item.osoba.spolupracovnik==1">Spolupracovník</div>
                    <div v-if="props.item.osoba.klient==1">Klient</div>
                  </td>
                  <td style="min-width: 250px">
                    <v-layout row wrap>
                      <v-flex v-for="(p, n) in props.item.penezenky" class="text-xs-right" xs12 :key="'osoba-' + props.item.id.toString() + '-penezenka-' + n.toString()">
                        {{p.aktualni_zustatek | formatMoney}} {{p.mena.zkratka}}
                      </v-flex>
                    </v-layout>
                  </td>
                  <td class="text-xs-right">
                    <router-link :to="{ path: '/klienti/' + props.item.osoba.id + '/elektronicka-penezenka' }" target="_blank">
                      <v-btn color="primary" depressed class="ma-0"><v-icon class="mr-2">remove_red_eye</v-icon>Detail</v-btn>
                    </router-link>
                  </td>
                </template>
                <template slot="footer">
                  <tr>
                    <td colspan="2"><strong>Saldo:</strong></td>
                    <td>
                      <v-layout row wrap>
                        <v-flex v-for="(p, n) in sum" class="text-xs-right" xs12 :key="'saldo-' + n.toString()">
                          {{p.aktualni_zustatek | formatMoney}} {{p.mena.zkratka}}
                        </v-flex>
                      </v-layout>
                    </td>
                    <td></td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      headers: [
        { text: 'Osoba', value: 'osoba' },
        { text: 'Typ osoby', value: 'id', sortable: false },
        { text: 'Elektronické peněženky', value: 'aktualni_zustatek', align: 'right' },
        { text: 'Akce', value: 'penezenky', align: 'right', sortable: false }
      ],
      items: [],
      loadingTable: true,
      search: "",
      timeout: null,
      counter: 0,
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 25,
        sortBy: "osoba",
        totalItems: 0
      },
      dialogCreate: false,
      sending: false,
      dialogInit: {
        sporici_program: null,
        hlavni_cilovy_produkt_id: null,
        mena_id: null
      },
      newItem: null,
      sum: null,
      only_not_null: false,
      osoba: null
    }
  },
  watch: {
  	pagination: {
  		handler: function(newValue) {
        if (!this.loadingTable)
  			   this.load();
  		},
  		deep: true
  	},
    only_not_null () {
      this.pagination.page = 1;
      this.load();
    },
    osoba () {
      this.pagination.page = 1;
      this.load();
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.load();
  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load();
      }.bind(this), 200)
    },
    load: function() {
      this.counter++;
      this.loadingTable = true;
      window.API.post("prehledy/elektronicke-penezenky/search", {
        pagination: this.pagination,
        s: this.search,
        echo: this.counter,
        pouze_nenulove: this.only_not_null,
        osoba: this.osoba
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items.replace(body.data);
        this.sum = body.sum;
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Prehledy/PrehledElektronickychPenezenek.vue